module.exports = __webpack_public_path__ + "01_bob_brown.a1e68abc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/01_bob_brown.png
// module id = Sbz9
// module chunks = 0